export default __webpack_public_path__ + "static/media/GPA-TyphoonRecipeBanner-Background.8bcc836c.jpg";